import React from "react";

function Aboutcontent() {
    return (
        <div className="main-content">
            <div className="rs-breadcrumbs breadcrumbs-overlay">
                <div className="breadcrumbs-img">
                    <img src="assets/images/breadcrumbs/2.jpg" alt="Breadcrumbs " />
                </div>
                <div className="breadcrumbs-text white-color">
                    <h1 className="page-title">About Us</h1>
                    <ul>
                        <li>
                            <a className="active" href="/">Home</a>
                        </li>
                        <li>About Us</li>
                    </ul>
                </div>
            </div>


            <div id="rs-about" className="rs-about style1 pt-100 pb-100 md-pt-70 md-pb-70">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6 order-last padding-0 md-pl-15 md-pr-15 md-mb-30">
                            <div className="img-part">
                                <img className="" src="assets/images/about/about2orange.png" alt="About " />
                            </div>
                        </div>
                        <div className="col-lg-6 pr-70 md-pr-15">
                            <div className="sec-title">
                                <div className="sub-title orange">About CFIITM</div>
                                <h2 className="title mb-17">What is the CFIITM?</h2>
                                <div className="desc">Canadian Friends of IITM Foundation is a fundraising platform to support IIT Madras’ drive towards global excellence in engineering education and research. It is an IRS approved tax-exempt 501(c)3 non-profit entity established and managed by volunteer IITM alumni to primarily raise endowment funds for IIT Madras from alumni, corporations and foundations in the United States.</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div id="rs-team" className="rs-team style1 inner-style orange-color pt-94 pb-100 md-pt-64 md-pb-70 gray-bg">
                <div className="container">
                    <div className="sec-title mb-50 md-mb-30 text-center">
                        <div className="sub-title orange">Our Team</div>
                        <h2 className="title mb-0">Board Of Members</h2>
                    </div>
                    <div className="row">
                        <div className="col-lg-4 col-sm-6 mb-30">
                            <div className="team-item">
                                <img src="assets/images/team/1.jpg" alt="" />
                                <div className="content-part">
                                    <h4 className="name"><a href="/">Prof. Dr. Venkatesh Mannar</a></h4>
                                    <span className="designation">Position</span>
                                    <ul className="social-links">
                                        <li><a href="#"><i className="fa fa-facebook"></i></a></li>
                                        <li><a href="#"><i className="fa fa-twitter"></i></a></li>
                                        <li><a href="#"><i className="fa fa-linkedin"></i></a></li>
                                        <li><a href="#"><i className="fa fa-google-plus"></i></a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-sm-6 mb-30">
                            <div className="team-item">
                                <img src="assets/images/team/1.jpg" alt="" />
                                <div className="content-part">
                                    <h4 className="name"><a href="/">Kamal Duggirala</a></h4>
                                    <span className="designation">Position</span>
                                    <ul className="social-links">
                                        <li><a href="#"><i className="fa fa-facebook"></i></a></li>
                                        <li><a href="#"><i className="fa fa-twitter"></i></a></li>
                                        <li><a href="#"><i className="fa fa-linkedin"></i></a></li>
                                        <li><a href="#"><i className="fa fa-google-plus"></i></a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-sm-6 mb-30">
                            <div className="team-item">
                                <img src="assets/images/team/3.jpg" alt="" />
                                <div className="content-part">
                                    <h4 className="name"><a href="/">GDS Ramkumar</a></h4>
                                    <span className="designation">Position</span>
                                    <ul className="social-links">
                                        <li><a href="#"><i className="fa fa-facebook"></i></a></li>
                                        <li><a href="#"><i className="fa fa-twitter"></i></a></li>
                                        <li><a href="#"><i className="fa fa-linkedin"></i></a></li>
                                        <li><a href="#"><i className="fa fa-google-plus"></i></a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-sm-6 md-mb-30">
                            <div className="team-item">
                                <img src="assets/images/team/1.jpg" alt="" />
                                <div className="content-part">
                                    <h4 className="name"><a href="/">Kannan Govindarajan</a></h4>
                                    <span className="designation">Position</span>
                                    <ul className="social-links">
                                        <li><a href="#"><i className="fa fa-facebook"></i></a></li>
                                        <li><a href="#"><i className="fa fa-twitter"></i></a></li>
                                        <li><a href="#"><i className="fa fa-linkedin"></i></a></li>
                                        <li><a href="#"><i className="fa fa-google-plus"></i></a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-sm-6 xs-mb-30">
                            <div className="team-item">
                                <img src="assets/images/team/3.jpg" alt="" />
                                <div className="content-part">
                                    <h4 className="name"><a href="/">Mahesh Panchagnula</a></h4>
                                    <span className="designation">Position</span>
                                    <ul className="social-links">
                                        <li><a href="#"><i className="fa fa-facebook"></i></a></li>
                                        <li><a href="#"><i className="fa fa-twitter"></i></a></li>
                                        <li><a href="#"><i className="fa fa-linkedin"></i></a></li>
                                        <li><a href="#"><i className="fa fa-google-plus"></i></a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-sm-6">
                            <div className="team-item">
                                <img src="assets/images/team/1.jpg" alt="" />
                                <div className="content-part">
                                    <h4 className="name"><a href="/">Marti G. Subrahmanyam</a></h4>
                                    <span className="designation">Position</span>
                                    <ul className="social-links">
                                        <li><a href="#"><i className="fa fa-facebook"></i></a></li>
                                        <li><a href="#"><i className="fa fa-twitter"></i></a></li>
                                        <li><a href="#"><i className="fa fa-linkedin"></i></a></li>
                                        <li><a href="#"><i className="fa fa-google-plus"></i></a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Aboutcontent;